module.exports = __webpack_public_path__ + "static/media/jj.b9707abe.png";